import React from 'react';
import { FileMetadata } from '@/services/apis/files';

interface ImageStepProps {
  content?: {
    image?: FileMetadata;
    images?: string[];
  };
  title?: string;
}

const ImageStep: React.FC<ImageStepProps> = ({ content, title }) => {
  // Handle both FileMetadata object and string URL
  const imageUrlString = typeof content?.image === 'string' 
    ? content.image 
    : content?.image?.url;
  const imageUrl = imageUrlString || content?.images?.[0];
  const images = content?.images || (imageUrlString ? [imageUrlString] : []);

  if (!imageUrl && images.length === 0) {
    return (
      <div className="text-center text-gray-500 dark:text-gray-400 py-8">
        No image available
      </div>
    );
  }

  if (images.length === 1) {
    return (
      <div className="space-y-4">
        <div className="relative w-full rounded-lg overflow-hidden">
          <img
            src={imageUrl || images[0]}
            alt={title || 'Step image'}
            className="w-full h-auto object-contain"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {images.map((image, index) => (
          <div key={index} className="relative w-full rounded-lg overflow-hidden">
            <img
              src={image}
              alt={`${title || 'Step'} - Image ${index + 1}`}
              className="w-full h-auto object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageStep;

